import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navigateToUrl = (url) => {
    navigate(url);
  };
  return (
    <div className='sidebar'>
      <section key={1}>
        <ul>
          <li
            className={`${location.pathname.startsWith('/companies') ? 'active' : ''}`}
            onClick={() => navigateToUrl('companies')}
          >
            <img src={null} />
            <span>{t('sidebar_companies')}</span>
          </li>
          <li
            className={`${location.pathname.startsWith('/users') ? 'active' : ''}`}
            onClick={() => navigateToUrl('users')}
          >
            <img src={null} />
            <span>{t('sidebar_users')}</span>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default Sidebar;
